// src/admin/components/Disclosure.jsx
import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

export default function Disclosure({ title, defaultOpen = false, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{ marginBottom: '12px' }}>
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: '4px',
          background: 'transparent', border: 'none',
          color: '#3a3a3c', fontSize: '12px', fontWeight: 600,
          cursor: 'pointer', padding: '4px 0',
          fontFamily: "'DM Sans', sans-serif",
        }}
      >
        {open ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
        {title}
      </button>
      {open && <div style={{ marginTop: '8px' }}>{children}</div>}
    </div>
  );
}
